import { useEffect, useState } from 'react'

import { RISK_LEVELS, retrieveAssetsBreakdownData } from './libs'
import { ModelPortfolioWithAssetsBreakdown } from '../../../../types/ModelPortfolio'

export function useAssetsBreakdown() {
  const [modelPortfolios, setModelPortfolios] = useState<
    ModelPortfolioWithAssetsBreakdown[]
  >()
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const [error, setError] = useState<unknown>()

  useEffect(() => {
    async function fetchAssetsBreakdownDataData() {
      try {
        const assetsBreakdownData = await retrieveAssetsBreakdownData()

        const allowedModelPortfolios = assetsBreakdownData.filter(
          ({
            riskLevel,
          }: Pick<ModelPortfolioWithAssetsBreakdown, 'riskLevel'>) =>
            RISK_LEVELS.includes(riskLevel)
        )

        setModelPortfolios(allowedModelPortfolios)
      } catch (error) {
        setError(error)
      } finally {
        setIsLoaded(true)
      }
    }

    fetchAssetsBreakdownDataData()
  }, [])

  return {
    assetsBreakdownData: modelPortfolios,
    isLoaded,
    error,
  }
}
